import { render } from "preact";
import { App } from "./app.tsx";

const root = document.getElementById("app");
if (!root) throw new Error("the page has no #app element");
render(<App />, root);
